import React from 'react'
import Slides from '../slides/Slides'

const Seguros = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"seguros"}/>
         <div className="section white py-5 animated fadeIn">
            <div className="container">
               
               {/* SECCIÓN ART */}
               <div className="row center mb-4">
                  <h4 className="light-blue-text text-accent-3 institutional-title">ART</h4>
               </div> 
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Somos una aseguradora regional, nuestro ámbito de actuación está concentrado en las provincias de Jujuy y Salta. El ámbito de actuación regional genera una fuerte ventaja competitiva, una relación personal con nuestros asegurados, y sus trabajadores. Todo ello, nos permitió ser la aseguradora N° 1 de la Provincia de Jujuy y dentro de las cinco principales ART de la Provincia de Salta.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           El seguimiento de los accidentados, es realizado por nuestros profesionales, contamos con un plantel de atención permanente en nuestras oficinas centrales, con lo cual tenemos garantizado el control de todos los accidentados.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           El Área de Prevención con un plantel numeroso de profesionales capacitados en los más variados riesgos, nos permite llegar a la concientización necesaria en los empleados / obreros sobre el uso de Elementos de Protección Personal (E.P.P.), en donde nuestra política es trabajar codo a codo con el empleador en esta difícil tarea, incluso en algunas ocasiones entregando sin cargo EPP a los empleadores, con instructivos alusivos a los beneficios que su uso, genera a todas las partes en las relaciones laborales.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SECCIÓN GRANIZO */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '2rem' }}>Granizo</h5>
               </div>
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Contamos con un plantel de profesionales con más de 30 años de experiencia en el riesgo, y tecnología de punta para la medición y evaluación de riesgos.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Somos la única aseguradora que tiene cobertura de granizo para nuestros asegurados con una protección activa como lo es el Sistema de Lucha Antigranizo contratado con la empresa LATSER S.A.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Nos encontramos dentro de las principales cinco aseguradoras nacionales de Riesgos Agropecuarios y Forestales.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Contamos con Reaseguradores de primer nivel, que nos permiten la tranquilidad de nuestros accionistas y nuestros asegurados.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SECCIÓN AUTOMOTORES */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '2rem' }}>Automotores</h5>
               </div>
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Se cubre la responsabilidad civil del asegurado hacia terceros (transportados o no), también los daños de casco por incendio, robo y destrucción total o parcial del vehículo asegurado. Además, LATITUD SUR brinda seguros para máquinas agrícolas y de sus implementos. Todos estos seguros, se otorgan en la medida en que, al momento del siniestro, el vehículo y su conductor cumplan con la normativa vigente en cuanto a circulación y conducción del mismo.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SECCIÓN VIDA COLECTIVO */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '2rem' }}>Vida Colectivo</h5>
               </div>
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           La experiencia y solvencia alcanzada desde que el sector tabacalero jujeño compró la aseguradora nos llevó a brindarle a nuestros trabajadores cubiertos un Seguro de Vida que genera la confianza y las respuestas necesarias para empresas de primera línea.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Desde hace varios años, somos la Aseguradora de Vida Colectivo del Poder Judicial de la provincia de Jujuy, como ejemplo de nuestros principales asegurados.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SECCIÓN SEGURO DE INCENDIO */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '2rem' }}>Seguro de Incendio</h5>
               </div>
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           En esta cobertura nuestro cliente principal son los productores tabacaleros. Cubrimos cualquier daño que por Incendio sufra una estufa de tabaco, al momento del curado de este último. La cobertura consiste en una suma asegurada para el edificio (dependiendo del estado y características del mismo) y otra para el contenido de la misma, en función a la capacidad de la estufa, ajustable al momento del siniestro.
                        </p>
                     </div>
                  </div>
               </div>

            </div>      
         </div>
      </>
   )
}

export default Seguros